import { ContactSelect } from 'browser/components/atomic-elements/atoms/select/contact-select/contact-select'
import LabelFieldFactory from 'browser/components/atomic-elements/higher-order-components/label-field-factory'
const ContactSelectField = LabelFieldFactory({ InputComponent: ContactSelect })
export {ContactSelectField}
